export default __webpack_public_path__ + "static/media/cardinal_black.b169cd4e.svg";